import React, { useMemo } from "react";

import { type CategoricalBreakdownConfig } from "@north-beam/nb-common";
import { Select } from "@shared/selects";

interface BreakdownSelectProps {
  className?: string;
  isLoading: boolean;
  breakdown: string;
  breakdownConfigs: CategoricalBreakdownConfig[];
  onChange: (obj: any) => void;
}

export function BreakdownSelect({
  className,
  isLoading,
  breakdown,
  breakdownConfigs,
  onChange,
}: BreakdownSelectProps) {
  const breakdownOptions = useMemo(
    () =>
      breakdownConfigs.map((v) => ({
        value: v.key,
        label: v.name,
      })),
    [breakdownConfigs],
  );

  return (
    <Select
      label="BREAKDOWN"
      className={className}
      isLoading={isLoading}
      value={breakdown}
      options={breakdownOptions}
      placeholder="Add breakdown..."
      icon={<i className="fa-regular fa-sharp fa-chart-pie" />}
      onChange={onChange}
    />
  );
}
